module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_5.32ccc621.png";